import React, { Component } from 'react';

import { Http } from '../../../../support';
import LoadingButton from '../../../../facturotopia/LoadingButton';

class TimbradoMasivoTicketsItemActions extends Component {

  state = {
    busy: false,
    showConfirm: false
  }

  handleOnCancelActionClick = () => {
    this.setState({
      showConfirm: true
    });
  }

  handleOnDownloadActionClick = async () => {
    this.setState({
      busy: true
    });

    const { selectedRowKeys } = this.props;

    try {
      const params = {
        download: 1,
        from: this.props.from,
        to: this.props.to,
        tickets: selectedRowKeys,
        as: 'link'
      }

      const response = await Http.get(`${window.BONJOUR_URL}/api/timbrado-masivo/comprobantes/tickets`, { params });

      window.location = response.data.link;
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  handleOnAction = (action) => {
  }

  handleOnRetryStampActionClick = async () => {
    this.setState({
      retry: true
    });

    const { selectedRows } = this.props;

    const retryTickets = selectedRows.filter(function (item) {
      return item.status === -2 || item.status === -3
    }).map(function(item) {
      return item.id;
    });

    const body = {
      tickets: retryTickets
    }

    try {
      const response = await Http.post(`api/timbrado-masivo/comprobantes/retry`, body);

      if (!!response) {
        window.ToastManager.show({
          variant: 'success',
          title: 'Reintento de timbrado.',
          message: response?.message
        })
      }
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message
      });
    } finally {
      this.setState({
        retry: false
      });
    }
  }

  render() {
    const { selectedRows } = this.props;
    const { busy, retry } = this.state;

    const retryStampTickets = selectedRows.filter(function (item) {
      return item.status === -3
    });

    return (
      <>
      { (selectedRows.length > 0) && (
          <LoadingButton
            variant="secondary"
            className="mr-2"
            loading={ busy }
            onClick={ this.handleOnDownloadActionClick }
          >
            { retry === true ? 'Descargando...' : 'Descargar seleccionados' }
          </LoadingButton>
        )}

        { (retryStampTickets.length > 0) && (
          <LoadingButton
            variant="secondary"
            className="mr-2"
            loading={ retry }
            onClick={ this.handleOnRetryStampActionClick }
          >
            { retry === true ? 'Procesando...' : 'Reintentar' }
          </LoadingButton>
        )}
      </>
    )
  }
}

export default TimbradoMasivoTicketsItemActions;